/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import { CHAT } from '@/store/types';
import { StoreActionEnv } from '@/store/actions';
import * as api from '@/api/chat';
import { chatLogin } from '@/utils/authorization';

export interface StoreChatUserBlockState {
  list: string[];
}

export default {
  namespaced: true,
  state: {
    list: null,
  },
  actions: {
    [CHAT.GET_BLACK_LIST](
      { state, commit }: StoreActionEnv<StoreChatUserBlockState>,
      { reload, refresh } = { reload: false, refresh: false },
    ) {
      if (!state.list) {
        reload = true;
      }
      if (refresh ? state.list : reload) {
        return new Promise((resolve, reject) => {
          chatLogin().then(({ appid }) => {
            api.getBlacklist(appid).then((res) => {
              commit(CHAT.GET_BLACK_LIST, {
                list: res.data || [],
              });
              resolve();
            }).catch(reject);
          }).catch(reject);
        });
      }
      return Promise.resolve();
    },
    [CHAT.ADD_BLACK_LIST]({ dispatch }: StoreActionEnv<StoreChatUserBlockState>, { uids }) {
      return new Promise((resolve, reject) => {
        chatLogin().then(({ appid }) => {
          api.addToBlacklist(appid, uids).then((res) => {
            dispatch(CHAT.GET_BLACK_LIST, { refresh: true }).then(() => {
              resolve(res);
            });
          }).catch(reject);
        }).catch(reject);
      });
    },
    [CHAT.DELETE_BLACK_LIST]({ dispatch }: StoreActionEnv<StoreChatUserBlockState>, { uids }: { uids: string[] }) {
      return new Promise((resolve, reject) => {
        chatLogin().then(({ appid }) => {
          api.removeFromBlacklist(appid, uids).then((res) => {
            dispatch(CHAT.GET_BLACK_LIST, { refresh: true }).then(() => {
              resolve(res);
            });
          }).catch(reject);
        }).catch(reject);
      });
    },
  },
  mutations: {
    [CHAT.GET_BLACK_LIST](state, { list } = { list: [] }) {
      state.list = list;
    },
  },
};
